import React, { useEffect, useState } from 'react';

import {Link, useNavigate, useParams} from "react-router-dom";
import { startOfMonth, endOfMonth, format, addMonths, parse, getYear, setMonth, getMonth, setYear } from 'date-fns';
import { set } from 'immutadot/core';
import { asMoney } from '../../utils';
import { FieldTable } from '../../components/FieldTable/FieldTable';
import isEqual  from 'react-fast-compare';
import { Campaign, useSalesTeamQueryQuery, useSearchCampaignQueryQuery } from '../../generated/graphql';
import { FieldTableColumnProps } from 'components/FieldTable/FieldTableTypes';
import {Button, IconButton, styled} from "@mui/material";
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight
} from "@mui/icons-material";
import {SalesTeamSelect} from "../../components/MaterialSelects/SalesTeamSelect";
import {SalesReportTypeSelect} from "../../components/MaterialSelects/SalesReportTypeSelect";
import { SelectId } from '../../components/MaterialSelects/SelectId';
import {NonIdealState} from "../../components/NonIdealState";
import { variableCurrencyValue } from '../../components/field-table';
import { RegionSelectGrouped } from '../../components/MaterialSelects/RegionSelectGrouped';




const MonthPicker = (props)=> {
  let i;
  const now = new Date();
  const date = parse(props.value + '-01', 'yyyy-MM-dd', now);
  const month = getMonth(date);
  const year = getYear(date);
  const cy = getYear(now);
  const years = [];
  for (i = cy+1; i >= 2010; i--) {
    years.push({ id: i, label: i.toString() });
  }
  const months = [];
  const monthLabels = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  for (i = 0; i < 12; i++) {
    months.push({ id: i, label: monthLabels[i] });
  }
  const addMonth = (m) => () => {
    props.onChange({ target: { name: props.name, value: format(addMonths(date, m),'yyyy-MM') } });
    // do something with quarters here...
  };
  const changeMonth = (m) => {
    props.onChange({ target: { name: props.name, value: format(setMonth(date, m.target.value),'yyyy-MM') } });
  };
  const changeYear = (m) => {
    props.onChange({ target: { name: props.name, value: format(setYear(date, m.target.value),'yyyy-MM') } });
  };
  console.log('MONTH',month,year,months);
  return (<div className="month-control">
    <IconButton onClick={addMonth(-12)}><KeyboardDoubleArrowLeft/></IconButton>
    <IconButton onClick={addMonth(-1)}><KeyboardArrowLeft/></IconButton>
    <SelectId labelField="label" minWidth="10rem" simpleSelect={true} valueIsId={true} name="month" onChange={changeMonth} options={months} value={month} label="Month"/>
    <SelectId labelField="label" minWidth="10rem" simpleSelect={true} valueIsId={true} name="year" onChange={changeYear} options={years} value={year} label="Year"/>
    <IconButton onClick={addMonth(1)}><KeyboardArrowRight/></IconButton>
    <IconButton onClick={addMonth(12)}><KeyboardDoubleArrowRight/></IconButton>
  </div>);
};


const nowT = new Date();
const now = {
  startOfMonth: startOfMonth(nowT),
  year: getYear(nowT),
  month: getMonth(nowT),
  quarter: Math.floor(getMonth(nowT) / 3),
  half: Math.floor(getMonth(nowT) / 6)
};

const quarters = [
  { label: 'Q1', id: 0 },
  { label: 'Q2', id: 1 },
  { label: 'Q3', id: 2 },
  { label: 'Q4', id: 3 }
];

const halves = [
  { label: 'H1', id: 0 },
  { label: 'H2', id: 1 }
];

const statuses = [
  { label: 'Confirmed', id: 'confirmed' },
  { label: 'Draft', id: 'draft',  },
  { label: 'Quote', id: 'quote',  },
  { label: 'Confirmed and Quote', id:'confirmed_quote' },
  { label: 'Confirmed, Quote and Draft', id:'confirmed_quote_draft' }
];
const status_values = {
  'confirmed_quote_draft': ['Part Paid','Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced', 'Quote','Draft'],
  'confirmed_quote': ['Part Paid','Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced', 'Quote'],
  'confirmed': ['Part Paid','Paid', 'To invoice', 'Invoiced', 'Confirmed', 'Part Invoiced'],
  'quote':['Quote'],
  'draft':['Draft']
};

function d2(v) {
  if(!v) return '00';
  if(v<10) { v = '0'+v; }
  return v;
}

const SalesReport = () => {
  // switch this to use URL
  // /report/[periodType]/[value]/[salesTeam]/[status]
  //const loc = useLocation();
  const baseState = useParams();
  const navigate = useNavigate();
  const formState = {...baseState};
  let variables:any = null;
  const nowDate = new Date();
  //formState.status = baseState.status&&baseState.status?.length?(baseState.status.toString()).split(','):[];

  // Update visibility when sales team changes or new data is loaded
  const { data: salesTeamData, loading: salesTeamLoading } = useSalesTeamQueryQuery();
  const [showRegionalCities, setShowRegionalCities] = useState(false);
  useEffect(() => {
    if (!salesTeamLoading && salesTeamData?.salesTeams) {
      const selectedTeam = salesTeamData.salesTeams.find(
        (team) => team.id === formState.salesTeam
      );

      const hasRegionalAllocation = selectedTeam?.supports_regional_am_allocation === true;
      setShowRegionalCities(hasRegionalAllocation);
    }
  }, [formState.salesTeam, salesTeamData, salesTeamLoading]);

  useEffect(()=> {
    // default somewhere sane
    const newState = {...formState};
    if(!formState.salesTeam) {
      newState.salesTeam = 'all';
    }
    if(!formState.periodType) {
      newState.periodType = 'month';
    }
    if(!formState.status) {
      newState.status = 'confirmed';
    }
    if(!formState.period) {
      switch(newState.periodType) {
        case 'year':
          newState.period = now.year.toString();
        break;
        case 'month':
          newState.period = now.year+'-'+(now.month+1);
        break;
        case 'quarter':
          newState.period = now.year+'-'+now.quarter;
        break;
        case 'half':
          newState.period = now.year+'-'+now.half;
        break;
      }
    }
    if (!formState.cities) {
      newState.cities = 'all';
    }
    if(!isEqual(formState,newState)) {
      console.log('goto from useEffect');
      goTo(newState);
    }
  },[formState]);
  let ps = [];
  // periodType changes how we interpret period
  switch(formState.periodType) {
    case 'month':
      ps = formState.period.split('-');
      formState.currentYear = ps[0];
      if(parseInt(ps[1])<1) { ps[1] = '1'; }
      formState.currentMonth = parseInt(ps[1],10).toString();
      formState.currentMonthYear = ps[0]+'-'+ps[1];
      break;
    case 'quarter':
      ps = formState.period.split('-');
      formState.currentYear = ps[0];
      formState.currentQuarter = ps[1];
    break;
    case 'half':
      ps = formState.period.split('-');
      formState.currentYear = ps[0];
      formState.currentHalf = ps[1];
    break;
    case 'year':
      formState.currentYear = formState.period;
    break;
  }

  const goTo = function(state) {
    if(isEqual(state,formState)) return;
    console.log('goTo',state,formState);
    navigate(
      `/sales/${state.periodType}/${state.period}/${state.salesTeam || 'all'}/${state.status}/${state.cities || 'all'}`
    );  
  }
  const setFormState = function(v) {
    console.log('[GLookup] year setformstate',v);
    let val = {...formState};
    if( typeof v == 'function') {
      val = v(val);
    } else {
      Object.entries(v).forEach(([k,v]) => {
        val[k] = v as string;
      });
    }
    if(val.periodType!=formState.periodType) {
      switch(val.periodType) {
        case 'year':
          val.period = val.currentYear;
        break;
        case 'month':
          val.period = val.currentYear+'-01';
          break;
        case 'quarter':
          val.period = val.currentYear+'-0';
          break;
        case 'half':
          val.period = val.currentYear+'-0';
          break;
      }
    }
    goTo(val);
  }
  const years = [];
  for (let i = now.year - 5; i < now.year + 2; i++) {
    years.push({ label: i.toString(), id: i });
  }
  let from = null, to = null;
  switch (formState.periodType) {
    case 'month':
      variables = {
        completion_date_between: {
          from: formState.currentMonthYear+'-01',
          to: format(endOfMonth(parse(formState.currentMonthYear+'-01','yyyy-MM-dd',nowDate)), 'yyyy-MM-dd')
        }
      };
      break;
    case 'quarter':
      const quarterIdx = parseInt(formState.currentQuarter);
      const quarterYear = formState.currentYear;
      from = parse(quarterYear + '-' + d2((quarterIdx * 3) + 1) + '-01', 'yyyy-MM-dd', new Date());
      to = parse(quarterYear + '-' + d2((quarterIdx + 1) * 3) + '-01', 'yyyy-MM-dd', new Date());
      variables = {
        completion_date_between: {
          from: format(from, 'yyyy-MM-dd'),
          to: format(endOfMonth(to), 'yyyy-MM-dd'),
        }
      };
      break;
    case 'half':
      const halfIdx = parseInt(formState.currentHalf);
      const halfYear = formState.currentYear;
      console.log(parse(halfYear + '-' + d2((halfIdx * 6) + 1) + '-01','yyyy-MM-dd',nowDate),halfYear + '-' + d2((halfIdx + 1) * 6) + '-01');
      from = parse(halfYear + '-' + d2((halfIdx * 6) + 1) + '-01', 'yyyy-MM-dd', nowDate);
      to = parse(halfYear + '-' + d2((halfIdx + 1) * 6) + '-01', 'yyyy-MM-dd', nowDate);
      variables = {
        completion_date_between: {
          from: format(from, 'yyyy-MM-dd'),
          to: format(endOfMonth(to), 'yyyy-MM-dd'),
        }
      };
      break;
    case 'year':
      const currentYear = formState.currentYear;
      from = parse(currentYear + '-01-01', 'yyyy-MM-dd', new Date());
      to = parse(currentYear + '-12-01', 'yyyy-MM-dd', new Date());
      variables = {
        completion_date_between: {
          from: format(from, 'yyyy-MM-dd'),
          to: format(endOfMonth(to), 'yyyy-MM-dd'),
        }
      };
      break;
      default: 
        variables = {
          skip: true
        }
      break;
  }
  switch(formState.salesTeam) {
    case 'all':
      //variables.sales_team_ids = [];
      variables.sales_team_all = true;
      variables.sales_team_core = false;
    break;
    case 'core':
      //variables.sales_team_ids = [];
      variables.sales_team_all = false;
      variables.sales_team_core = true;
    break;
    default:
      variables.sales_team_ids = [formState.salesTeam];
      variables.sales_team_all = false;
      variables.sales_team_core = false;
    break;
  }
  /*if (formState.salesTeam !== 'all' && formState.salesTeam) {
    variables.sales_team_ids = [formState.salesTeam];
  }*/
  if(formState.status != '') {
    variables.status_in = status_values[formState.status];
  }
  if (formState.cities && formState.cities !== 'all') {
    variables.regional_am_revenue_id_in = [formState.cities];
  }  
  //variables.status_in = formState.status;
  const { loading, error, data } = useSearchCampaignQueryQuery({
    variables: variables,
    fetchPolicy: 'network-only',
    skip: !!variables?.skip
  });
  const onChange = (evt) => {
    setFormState((oldVal) => {
      return set(oldVal, evt.target.name, evt.target.value) 
    });
  }
  const campaigns = (!loading && !error && data) ? data.campaigns.data : [];
  const renderBody = React.useMemo(() => {
    /*if (loading) {
      return <WaitSpinner type="absolute"/>;
    }*/
    if (error) {
      return <NonIdealState title="An error has occurred" />;
    }
    const columns:FieldTableColumnProps<Campaign>[] = [{
      header: 'Job Ref',
      accessor: 'job_reference',
      dataType:'link',
      options: {
      // eslint-disable-next-line react/display-name
        getLink: ({ field }) => {
          return '/campaigns/' + field.value;
        }
      }
    }, {
      header: 'Name',
      accessor: 'name',
      dataType:'default',
    }, {
      header: 'Status',
      accessor: 'status',
      dataType:'default',
      summaries: {
        // eslint-disable-next-line react/display-name
        header: () => <b style={{display:'flex',alignItems:'center'}}>Total</b>
      }
    },{
      header: 'Discounted Total',
      accessor: 'total_price_reporting',
      dataType: 'currency',
      options: {
        'currency':{
          accessor:'reportingCurrency'
        }
      },
      readOnly:true,
      summaries: {
        header: ({ currency,rows }) => {
          let total = 0;
          const currencies = {};
          // if >1 currency, suppress the total
          // otherwise show the total in the quoted currency
          let currencyQuoted = null;
          rows.forEach((v) => {
            total += v.total_price_reporting;
            currencies[v.reportingCurrency?.id] = true;
            if(v.reportingCurrency) {
              currencyQuoted = v.reportingCurrency;
            }
          });
          if(Object.keys(currencies)?.length>1) { return ''; }
          return variableCurrencyValue({ currency: currencyQuoted, value:total, places:2, comma:true });
        }
      }
    }, {
      header: 'Job Costs',
      accessor: 'totalCostsReporting',
      dataType: 'currency',
      readOnly:true,
      options: {
        'currency':{
          accessor:'reportingCurrency'
        }
      },
      summaries: {
        header: ({ rows,currency }) => {
          let total = 0;
          const currencies = {};
          let currencyQuoted = null;
          rows.forEach((v) => {
            total += v.totalCostsReporting;
            currencies[v.reportingCurrency?.id] = true;
            if(v.reportingCurrency) {
              currencyQuoted = v.reportingCurrency;
            }
          });
          if(Object.keys(currencies)?.length>1) { return ''; }
          return variableCurrencyValue({ currency: currencyQuoted, value:total, places:2,comma:true });
        }
      }
    }, {
      header: 'Contribution',
      accessor: 'margin',
      dataType: 'currency',
      readOnly:true,
      options: {
        getValue: ({ row }) => (row.total_price_reporting - row.totalCostsReporting),
        'currency':{
          accessor:'reportingCurrency'
        }
      },
      summaries: {
        header: ({ rows,currency }) => {
          let total = 0, totalCosts = 0;
          const currencies = {};
          let currencyQuoted = null;
          rows.forEach((v) => {
            total += v.total_price_reporting;
            totalCosts += v.totalCostsReporting;
            currencies[v.reportingCurrency?.id] = true;
            if(v.reportingCurrency) {
              currencyQuoted = v.reportingCurrency;
            }
          });
          if(Object.keys(currencies)?.length>1) { return ''; }
          if (!total) { return ''; }
          return variableCurrencyValue({ currency: currencyQuoted, value:total-totalCosts, places:2,comma:true });
        }
      }
    },
    {
      header: 'Contribution Margin',
      accessor: 'margin-b',
      className: 'column-currency column-width-wide',
      dataType: 'number',
      readOnly:true,
      options: {
        exportFormat: 'percentage',
        renderViewer:(props)=> {
          const value = props.options?.getValue ? props.options.getValue(props) : props.field.value;
          return value+'%';
//          (100*(row.total_price_reporting - row.totalCosts) / row.total_price_reporting).toFixed(2) + '%';
        },
        getValue: ({ row }) => {
          const value = row.total_price_reporting-row.totalCostsReporting;
          if(!value || !row.total_price_reporting) return 0;
          return (100*(row.total_price_reporting - row.totalCostsReporting) / row.total_price_reporting).toFixed(2)
        }
      },
      summaries: {
        header: ({ rows }) => {
          let total = 0, totalCosts = 0;
          const currencies = {};
          rows.forEach((v) => {
            total += v.total_price_reporting;
            totalCosts += v.totalCostsReporting;
            currencies[v.reportingCurrency?.id] = v.reportingCurrency;
          });
          if(Object.keys(currencies)?.length>1) { return ''; }
          if (!total) { return ''; }
          return (100 * (total - totalCosts) / total).toFixed(2) + '%';
        }
      }
    }, {
      header: 'Invoice Number',
      accessor: 'invoice',
      dataType: 'default',
      exportOnly: true
    }, {
      header: 'Purchase Order',
      accessor: 'purchase_order',
      dataType: 'default',
      exportOnly: true
    }, {
      header: 'Completion Date',
      accessor: 'completion_date',
      exportOnly: true,
      dataType: 'date'
    },{
      header:'Account Manager',
      accessor:'ourContact.name',
      dataType: 'default',
      exportOnly:true
    },{
      header:'Sales Team',
      accessor:'salesTeam.name',
      dataType: 'default',
      exportOnly:true
    },{
      header:'Client Accounts Company',
      accessor:'clientCompany.accounts_company',
      dataType: 'default',
      exportOnly:true
    },{
      header:'Client Sales Company',
      accessor:'clientCompany.sales_company',
      dataType: 'default',
      exportOnly:true
    }];
    return (<FieldTable
    className="sales-report"
      summaries={{ header: (oldRow, newRow) => { return (!newRow ? 'header' : '') } }}
      hasDelete={false}
      loading={loading} values={campaigns} columns={columns} />);
  }, [loading, error, campaigns]);
  if(!variables) { return null; }
  if(!formState.status) return <div>...</div>;
  // TODO: delete this weird bit of code
  /*let totalContribution = 0;
  campaigns.forEach((row)=>{
    totalContribution +=row.total_price_reporting-row.totalCosts;
  });*/
  return (
    <React.Fragment>
      <div className="sales-report__controls">
        <div className="sales-report__controls__type"><SalesReportTypeSelect valueIsId={true} simpleSelect={true} name="periodType" onChange={onChange} value={formState.periodType} label="Period"/></div>
        <div className="sales-report__controls__team"><SalesTeamSelect minWidth="15rem" valueIsId={true} simpleSelect={true} allowBlank={true} blankLabel="All Sales Teams" extraOptions={[{id:'core',name:'Core Sales Teams'}]} label="Sales Team"
        value={formState.salesTeam} onChange={(evt)=>{
            setFormState({salesTeam:evt.target.value})
        }} name="salesTeam" /></div>
        {showRegionalCities && (
          <div className="sales-report__controls__status">
            <RegionSelectGrouped
              valueIsId={true} 
              allowBlank={true}
              blankLabel="All Regional Cities"
              label="Regional Cities"
              name="cities"
              onChange={(evt) => {setFormState({cities: evt.target.value,}) }}
              value={formState.cities || null}
              />
          </div>
        )}
        {formState.periodType === 'month' &&
          <div className="sales-report__controls__month"><MonthPicker valueIsId={true} value={formState.currentMonthYear} name="currentMonthYear" onChange={(evt)=>{
            setFormState({period:evt.target.value});
          }} label="Month" /></div>
        }
        {formState.periodType === 'quarter' &&
          <div className="sales-report__controls__quarter month-control">
            <SelectId name="currentQuarter" labelField="label" simpleSelect={true} label="Quarter" onChange={(evt)=>{
              setFormState({period:formState.currentYear+'-'+evt.target.value})
            }} options={quarters} value={formState.currentQuarter} />
            <SelectId name="currentYear" labelField="label" label="Year" simpleSelect={true} onChange={(evt)=>{
              setFormState({period:evt.target.value+'-'+formState.currentQuarter});
            }} options={years} value={formState.currentYear} />
          </div>
        }
        {formState.periodType === 'half' &&
          <div className="sales-report__controls__quarter month-control">
            <SelectId name="currentHalf" labelField="label" label="Half" simpleSelect={true} onChange={(evt)=>{
              setFormState({period:formState.currentYear+'-'+evt.target.value})
            }} options={halves} value={formState.currentHalf} />
            <SelectId name="currentYear" labelField="label"  label="Year" simpleSelect={true} onChange={(evt)=>{
              setFormState({period:evt.target.value+'-'+formState.currentHalf})
            }} options={years} value={formState.currentYear} />
          </div>
        }
        {formState.periodType === 'year' &&
          <div className="sales-report__controls__quarter month-control">
            <SelectId name="currentYear" label="Year" labelField="label" simpleSelect={true} onChange={(evt)=>{
              setFormState({period:evt.target.value});
            }} options={years} value={formState.currentYear} />
          </div>
        }
        <div className="sales-report__controls__status">
          <SelectId labelField="label" label="Status" name="status" simpleSelect={true} onChange={onChange} options={statuses} value={formState.status} 
          style={{flexBasis:'15rem'}}/>
        </div>
      </div>
      {renderBody}
    </React.Fragment>
  );
}
export default SalesReport;
